import { NotificationsSettings as NotificationsSettingsComponent } from '@carboncopyco/components';
import { Outlet } from 'react-router-dom';
import WorkspaceLayout from '../../components/Workspaces/WorkspaceLayout';

export function NotificationsSettings() {
  return (
    <WorkspaceLayout>
      <div className="bg-ds-accent3-100 g-ds-accent3-200 h-full overflow-y-auto">
        <NotificationsSettingsComponent />
        <Outlet />
      </div>
    </WorkspaceLayout>
  );
}

export default NotificationsSettings;
